module.exports = "/assets/data/9cf8dc460f697712b01b676e217f8ad5-SS4.data.json";